export const statesConstants = {
    STATES_START: 'states:start',
    STATES_STOP: 'states:stop',
    STATES_STATES: 'states:states',
    STATES_CLEAR: 'states:clear',
};
